import 'vite/modulepreload-polyfill';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Loader from './components/common/Loader';
import LazyBootstrap from './LazyBootstrap';
import { initializeThemeMode } from './utils/themeMode';
import './index.css';

initializeThemeMode();

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

const element = (
    <Suspense fallback={<Loader height="screen" />}>
        <LazyBootstrap />
    </Suspense>
);

root.render(element);
